import React, { useEffect, useState } from "react";
import {
  StyledSlideshowDescription,
  StyledSlideshow,
  StyledTileGrid,
  StyledTile,
  StyledMadeBy,
  StyledVideo,
  StyledVideoContainer,
  StyledDescriptionContainer,
  StyledBorderEdge,
  StyledChevronLeft,
  StyledChevronRight,
} from "./styles";
import { slideshow, tileGrid } from "./staticData";

const MadeBy = ({ subscription, targetPlan, handleSelectPlan }) => {
  const [selectedSlide, setSelectedSlide] = useState(0);
  const [userHovering, setUserHovering] = useState(false);

  useEffect(() => {
    const timeoutDur =
      slideshow[selectedSlide].duration < 18000
        ? 18000
        : slideshow[selectedSlide].duration;
    const timeout = setTimeout(() => {
      if (userHovering) {
        return;
      }
      if (selectedSlide === 3) {
        setSelectedSlide(0);
      } else {
        setSelectedSlide(selectedSlide + 1);
      }
      clearTimeout(timeout);
    }, timeoutDur);

    return () => clearTimeout(timeout);
  }, [userHovering, selectedSlide]);

  const handleSelectSlideShow = (index) => {
    setSelectedSlide(index);
  };

  return (
    <StyledMadeBy>
      <h1 className="by-writers-headline">Made by writers, for writers</h1>
      <span className="by-writers-sub-headline">With you every step from idea to final draft</span>
      <StyledSlideshow className="slideshow-container-container"
        onMouseEnter={() => {
          setUserHovering(true);
        }}
        onMouseLeave={() => {
          setUserHovering(false);
        }}
      >
        <div className="slideshow-container">
          <StyledChevronLeft
            onClick={(e) => {
              e.preventDefault();
              if (selectedSlide > 0) {
                setSelectedSlide(selectedSlide - 1);
              } else {
                setSelectedSlide(3);
              }
            }}
          />
          <StyledVideoContainer className="video-container">
            {slideshow.map((slide, i) => {
              const isSelected = selectedSlide === i;
              return (
                <StyledVideo className="video"
                  autoPlay
                  muted
                  loop
                  selected={isSelected}
                  src={slide.video}
                  key={"slideshow-video" + i}
                />
              );
            })}
          </StyledVideoContainer>
          <StyledChevronRight
            onClick={(e) => {
              e.preventDefault();
              if (selectedSlide < 3) {
                handleSelectSlideShow(selectedSlide + 1);
              } else {
                setSelectedSlide(0);
              }
            }}
          />
        </div>
        <StyledDescriptionContainer selected={selectedSlide}>
          <StyledBorderEdge />
          <ul className="description-uls">
            {slideshow.map((slide, i) => {
              const isSelected = selectedSlide === i;
              return (
                <StyledSlideshowDescription
                  key={"slideshow_desc" + i}
                  selected={isSelected}
                  onClick={() => {
                    handleSelectSlideShow(i);
                  }}
                >
                  {slide.text}
                </StyledSlideshowDescription>
              );
            })}
          </ul>
        </StyledDescriptionContainer>
      </StyledSlideshow>

      <span className="write-faster">
        Write faster and have more fun with Earth's most advanced long-form
        writing app
      </span>

      <StyledTileGrid>
        {tileGrid.map((tile, i) => {
          return (
            <StyledTile
              key={"tile-grid-" + i}
              overlayImage={tile.overlayImage && tile.overlayImage}
            >
              {tile.aboveText && <span className="above-text">{tile.aboveText}</span>}
              {tile.image && <img src={tile.image} />}
              <span>{tile.text}</span>
            </StyledTile>
          );
        })}
      </StyledTileGrid>

      <span className = "want-to-see">
        {" "}
        Wanna see how it all comes together? <br />{" "}
        <a target="_blank" href="https://youtu.be/LwUIAvOIGUE">
          Watch our demo video.
        </a>
      </span>

      {(!subscription || !subscription.currentPlan()) && (
        <button className="try-it-button"
          onClick={() => {
            handleSelectPlan(subscription, targetPlan);
          }}
        >
          {" "}
          Try it for free
        </button>
      )}
    </StyledMadeBy>
  );
};

export default MadeBy;
